module.exports = __webpack_public_path__ + "media/img/patient-hero-phone-61706c52fc9ed1cd0231ae2e7b1371c9.png";